import React, { useEffect, useState } from "react";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import Slider from "components/Slider";
import Input from "components/Input";
import { useQuery } from "@apollo/client";
import { GET_ALL_HOTEL_CHARGES } from "graphql/service";
import { Content, ItemContainer } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";

const RatePlan = () => {

  const [hotelCharges, setHotelCharges] = useState({});

  const { data: hotelChargesData, error } = useQuery(GET_ALL_HOTEL_CHARGES);

  useEffect(() => {
    if (hotelChargesData) {
      setHotelCharges(hotelChargesData.hotelChargesSettings);
    }
  }, [hotelChargesData]);



  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes("Validation")) {
        content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception);
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  return (
    <Card
      additionalstyle={`
        height: auto;
        align-self: flex-start;
      `}
    >
      <CardHeader>
        <div className="cardTitle">HOTEL CHARGES</div>
      </CardHeader>
      <Content>
        <ItemContainer>
          <div className="itemTitle">
            <span className="itemName">Early Check In Fee</span>
            <span className="slider">
              <Slider />
            </span>
          </div>
          <div className="itemValue">
            <Input
              mainPage
              title="CHARGE"
              value={hotelCharges.earlyCheckin?.amount || ""}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    earlyCheckin: {
                      ...prev.earlyCheckin,
                      amount: e.target.value,
                    },
                  };
                })
              }}
            />
          </div>
        </ItemContainer>
        <ItemContainer>
          <div className="itemTitle">
            <span className="itemName">Late Check Out Fee</span>
            <span className="slider">
              <Slider />
            </span>
          </div>
          <div className="itemValue">
            <Input
              mainPage
              title="CHARGE"
              value={
                hotelCharges.lateCheckOut?.amount || ""
              }
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    lateCheckOut: {
                      ...prev.lateCheckOut,
                      amount: e.target.value,
                    },
                  };
                });
              }}
            />
          </div>
        </ItemContainer>
        <ItemContainer>
          <div className="itemTitle">
            <span className="itemName">Parking (Per Night)</span>
            <span className="slider">
              <Slider />
            </span>
          </div>
          <div className="itemValue">
            <Input
              mainPage
              title="CHARGE"
              value={hotelCharges.parking?.amount || ""}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    parking: {
                      ...prev.parking,
                      amount: e.target.value,
                    },
                  };
                });
              }}
            />
          </div>
        </ItemContainer>{" "}
        <ItemContainer>
          <div className="itemTitle">
            <span className="itemName">Breakfast (Per Day)</span>
            <span className="slider">
              <Slider />
            </span>
          </div>
          <div className="itemValue">
            <Input
              mainPage
              title="CHARGE"
              value={ hotelCharges.breakfast?.amount || ""}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    breakfast: {
                      ...prev.breakfast,
                      amount: e.target.value,
                    },
                  };
                });
              }}
            />
          </div>
        </ItemContainer>
        <ItemContainer>
          <div className="itemTitle">
            <span className="itemName">No Show Fee</span>
            <span className="slider">
              <Slider />
            </span>
          </div>
          <div className="itemValue">
            <Input
              mainPage
              title="CHARGE"
              value={hotelCharges.noShow?.amount || ""}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    noShow: {
                      ...prev.noShow,
                      amount: e.target.value,
                    },
                  };
                });
              }}
            />
          </div>
        </ItemContainer>
        <ItemContainer>
          <div className="itemTitle">
            <span className="itemName">Overstay Penalty</span>
            <span className="slider">
              <Slider />
            </span>
          </div>
          <div className="itemValue">
            <Input
              mainPage
              title="CHARGE"
              value={hotelCharges.overstayPenalty?.amount || ""}
              onChange={(e) => {
                setHotelCharges((prev) => {
                  return {
                    ...prev,
                    overstayPenalty: {
                      ...prev.overstayPenalty,
                      amount: e.target.value,
                    },
                  };
                });
              }}
            />
          </div>
        </ItemContainer>
      </Content>
    </Card>
  );
};

export default RatePlan;
